import React, { useState, useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import SEO from './components/SEO';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import WhySection from './components/WhySection';
import Results from './components/Results';
import Areas from './components/Areas';
import Social from './components/Social';
import Reviews from './components/Reviews';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FloatingActions from './components/FloatingActions';

function App() {
  const [language, setLanguage] = useState('en');

  useEffect(() => {
    const savedLang = localStorage.getItem('bt_lang') || 'en';
    setLanguage(savedLang);
  }, []);

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    localStorage.setItem('bt_lang', lang);
    document.documentElement.lang = lang;
  };

  return (
    <HelmetProvider>
      <div className="App" id="top">
        <SEO language={language} />
        <Header language={language} onLanguageChange={handleLanguageChange} />
        <main>
          <Hero language={language} />
          <Services language={language} />
          <WhySection language={language} />
          <Results language={language} />
          <Areas language={language} />
          <Social language={language} />
          <Reviews language={language} />
          <FAQ language={language} />
          <CTA language={language} />
          <Contact language={language} />
        </main>
        <Footer language={language} />
        <FloatingActions />
      </div>
    </HelmetProvider>
  );
}

export default App;
